import { Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Download2LineIcon from "remixicon-react/Download2LineIcon";
import Edit2LineIcon from "remixicon-react/Edit2LineIcon";
import useJStyles from "$hooks/useJStyles";
import { BtnPoper, Button } from "$components";

export const ButtonImportList = ({ buttonList, title, disabled }: any) => {
  const { jclasses } = useJStyles();
  return (
    <BtnPoper
      BtnLabel={title}
      BtnComponent={Button}
      disabled={disabled}
      BtnProps={{
        variant: "outlined",
      }}
      BtnIcon={ExpandMoreIcon}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minWidth: "300px",
        }}
      >
        {buttonList.map((b: any, index: number) => (
          <Button
            onClick={b.onClick}
            variant="text"
            className={jclasses.jBtnOnPopper}

            key={`buttonImport-${index}`}
            sx={{
              justifyContent: "flex-start",
              textAlign: "left",
              borderRadius: 0,
              color: "black !important",
              backgroundColor: "transparent !important",
              border: "none !important",
              padding: "6px",
              minWidth: "300px",
              "&:hover": {
                backgroundColor: "#e0e0e0 !important",
                color: "black !important",
                border: "none !important",
              },
              "&.MuiButton-text:hover": {
                backgroundColor: "#e0e0e0 !important",
              },
              "&.MuiButton-root:hover": {
                backgroundColor: "#e0e0e0 !important",
              },
              "& svg": {
                color: "black !important",
                marginRight: "8px",
              },
              "& .MuiButton-label": {
                color: "black !important",
              },
              "& span": {
                color: "black !important",
              },
            }}
          >
            {b.isUpdate ? (
              <Edit2LineIcon className={jclasses.jBtnIcon} />
            ) : (
              <Download2LineIcon className={jclasses.jBtnIcon} />
            )}
            {b.text}
          </Button>
        ))}
      </Box>
    </BtnPoper>
  );
};
